import { render, staticRenderFns } from "./ScheduleProgramDay.vue?vue&type=template&id=0c0f37d2&scoped=true"
import script from "./ScheduleProgramDay.vue?vue&type=script&lang=js"
export * from "./ScheduleProgramDay.vue?vue&type=script&lang=js"
import style0 from "./ScheduleProgramDay.vue?vue&type=style&index=0&id=0c0f37d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0f37d2",
  null
  
)

export default component.exports